import { observable, action, makeObservable } from 'mobx';

class MapStore {
  viewport = {
    center: { lng: -73.9954260224539, lat: 40.723244087001774 },
    zoom: 12,
    pitch: 0
  };

  bounds = null;
  status = 'loading';
  mode = 'view';
  popup = null;
  gl = null;
  deckRef = null;
  mapboxRef = null;
  shouldRedrawPoints = false;

  constructor() {
    makeObservable(this, {
      viewport: observable,
      gl: observable,
      shouldRedrawPoints: observable,
      bounds: observable,
      status: observable,
      mode: observable,
      popup: observable,
      setMode: action,
      setBounds: action,
      setViewPort: action,
      setStatus: action,
      setEditMode: action,
      setPopup: action
    });
  }

  setDeckRef(ref) {
    this.deckRef = ref;
  }

  setMode(mode) {
    this.mode = mode;
  }

  setMapboxRef(ref) {
    this.mapboxRef = ref;
  }

  setGl(gl) {
    this.gl = gl;
  }

  setBounds(bounds) {
    this.bounds = bounds;
  }

  setViewPort(viewport) {
    this.viewport = viewport;
  }

  setStatus(status) {
    this.status = status;
  }

  setEditMode(editMode) {
    this.editMode = editMode;
  }

  setShouldRedrawPoints(value) {
    this.shouldRedrawPoints = value;
  }

  setPopup(value) {
    this.popup = value;
  }
}

const store = new MapStore();
export default store;
